import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { HOME } from '../../constants';
import Burger from './Burger/Burger';
import HeaderLinks from './HeaderLinks/HeaderLinks';

import styles from './Header.module.scss';

const Header = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <>
      <div className={`${styles.header} ${styles['header--desktop']}`}>
        <Link to={HOME} className="logo">
          funeralApp
        </Link>

        <div className={styles.links}>
          <div className="d-block d-md-none">
            <Burger active={!!showMobileMenu} setActive={setShowMobileMenu} />
          </div>

          <div className="d-none d-md-block">
            <HeaderLinks />
          </div>
        </div>
      </div>

      <div
        className={`${styles.header} ${styles['header--mobile']} ${showMobileMenu ? 'active' : ''}`}
      >
        <HeaderLinks />
      </div>
    </>
  );
};

export default Header;
